import { assocIf } from '@btime/helpers'
import { propEq } from 'ramda'
import React from 'react'

import { formatFieldValues } from '../../../../utils/helpers/fields'
import { useGetFieldValuesAddressFromApi } from '../../../../utils/hooks/fieldValueAddress'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useServiceOrders } from '../_load/ServiceOrdersLoader'
import { usePlaces } from '../_load/PlacesLoader'

export const useFormatInitialState = initialItemValue => {
  const [loading, setLoading] = React.useState(true)
  const [data, setData] = React.useState([])

  const { placeIds, placeType } = useModalData()
  const serviceOrders = useServiceOrders()
  const places = usePlaces()
  const [getPlacesAddress, { loading: loadingAddress }] = useGetFieldValuesAddressFromApi()

  React.useEffect(() => {
    if (!!serviceOrders?.length) {
      setData(
        serviceOrders.map(item => ({
          ...item,
          ...assocIf(!!item?.group, 'userOrGroup', item?.group),
          ...assocIf(!!item?.user, 'userOrGroup', item?.user),
          fieldValues: formatFieldValues(item.fieldValues, 'service_orders')
        }))
      )
      setLoading(false)
      return
    }

    if (!!placeIds?.length) {
      getPlacesAddress(placeIds, placeType).then(addresses => {
        setData(
          places?.map(place => ({
            place,
            ...initialItemValue,
            address: addresses.find(propEq('originId', place?.id))?.value
          }))
        )
        setLoading(false)
      })
      return
    }

    setData([initialItemValue, initialItemValue])
    setLoading(false)
  }, [])

  return [data, { loading }]
}
